import {Fragment, memo} from 'react';

import styled from 'styled-components';

import {Link} from '~/shared/router';
import googlePlayEnImageSrc from '~/assets/download-the-app/google_play_en.png';
import googlePlayImageSrc from '~/assets/download-the-app/google_play.png';
import appStoreEnImageSrc from '~/assets/download-the-app/app_store_en.png';
import appStoreImageSrc from '~/assets/download-the-app/app_store.png';
import {body16Bold} from '~/shared/theme/typography';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {media} from '~/shared/theme/media';
import {trackEvent} from '~/shared/services/analytics';
import {getLocalizationService} from '~/shared/services/localisationService';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div`
  ${body16Bold}
`;

const Wrapper = styled.div.attrs({
  className: '.download-the-app-wrapper',
})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${media.minLargeMobile`
    flex-direction: row;
  `}
`;

const AppStoreImage = styled(ImageWithAlt)`
  display: block;
  width: 135px;
  height: 40px;
  ${media.minLargeTablet`
    ${({theme}) => !theme.isLTR && 'margin-left: 14px;'})
  `}
`;

const onAppClick = (platform: 'ios' | 'android') => {
  trackEvent('downloadApp_click', {linkType: 'footer', app_type: platform});
};

type FooterDownloadTheAppProps = {
  isIOS?: boolean;
  isAndroid?: boolean;
  iosLink?: string;
  androidLink?: string;
  unifiedLink?: string;
  noContainer?: boolean;
};

const FooterDownloadTheApp = ({
  isAndroid,
  isIOS,
  iosLink,
  androidLink,
  unifiedLink,
  noContainer,
}: FooterDownloadTheAppProps) => {
  const {t, currentLanguageKey} = getLocalizationService();

  const Container = noContainer ? Fragment : Root;

  return (
    <Container>
      <Title>{t('download_the_app')}</Title>
      <Wrapper>
        {!isIOS && (
          <Link href={iosLink || unifiedLink} target="_blank" allowOnClickOnTargetBlank onClick={() => onAppClick('android')} data-test-id="google-play-link">
            <AppStoreImage
              src={currentLanguageKey === 'en' ? googlePlayEnImageSrc : googlePlayImageSrc}
              alt={t('get_app_on_the', {storeName: 'Google Play'})}
            />
          </Link>
        )}
        {!isAndroid && (
          <Link href={androidLink || unifiedLink} target="_blank" allowOnClickOnTargetBlank onClick={() => onAppClick('ios')} data-test-id="app-store-link">
            <AppStoreImage
              src={currentLanguageKey === 'en' ? appStoreEnImageSrc : appStoreImageSrc}
              alt={t('get_app_on_the', {storeName: 'App Store'})}
            />
          </Link>
        )}
      </Wrapper>
    </Container>
  );
};

export default memo(FooterDownloadTheApp);
